  (function() {
    class GwtMediaWithText extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video = this.querySelector('.gwt-media-text-video-{{ section_id }}');
        if (this.video) {
          this.setupVideoAccessibility();
        }
      }

      setupVideoAccessibility() {
        this.video.addEventListener('play', function() {
          this.setAttribute('aria-live', 'polite');
        });

        this.video.addEventListener('pause', function() {
          this.setAttribute('aria-live', 'off');
        });
      }
    }

    customElements.define('gwt-media-with-text', GwtMediaWithText);
  })();